import { useState, ChangeEvent } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { createCoinType } from '@/api/stake-db';
import { CreateCoinTypeRequest } from '@/types/stake-db';

interface CoinTypeFormProps {
  onCreated?: () => void;
}

export default function CoinTypeForm({ onCreated }: CoinTypeFormProps) {
  const [formData, setFormData] = useState({
    symbol: '',
    contractAddr: '',
    network: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (field: string) => (event: ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.symbol) {
      toast.error('Symbol을 입력해주세요.');
      return;
    }
    if (!formData.contractAddr) {
      toast.error('Contract Address를 입력해주세요.');
      return;
    }
    if (!formData.network) {
      toast.error('Network를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const data: CreateCoinTypeRequest = {
        symbol: formData.symbol.toUpperCase(),
        contractAddr: formData.contractAddr,
        network: formData.network,
      };

      const re = await createCoinType(data);

      if (re.status === 200 || re.status === 201) {
        toast.success(re.data.message || '코인타입 등록 성공');
        setFormData({ symbol: '', contractAddr: '', network: '' });
        onCreated?.();
      } else {
        toast.error(re.data?.message || '코인타입 등록 실패');
      }
    } catch (error) {
      console.error('Create coin type error:', error);
      toast.error('코인타입 등록 실패');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Typography variant="h6" gutterBottom>
            코인타입 등록
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Stake-db 서비스에서 사용할 코인타입을 등록합니다.
          </Typography>
        </Grid>

        <Grid xs={12} sm={4}>
          <FormControl fullWidth required>
            <InputLabel>Symbol</InputLabel>
            <OutlinedInput
              value={formData.symbol}
              label="Symbol"
              onChange={handleChange('symbol')}
              placeholder="USDT"
            />
          </FormControl>
        </Grid>

        <Grid xs={12} sm={4}>
          <FormControl fullWidth required>
            <InputLabel>Network</InputLabel>
            <OutlinedInput
              value={formData.network}
              label="Network"
              onChange={handleChange('network')}
              placeholder="ethereum"
            />
          </FormControl>
        </Grid>

        <Grid xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Contract Address</InputLabel>
            <OutlinedInput
              value={formData.contractAddr}
              label="Contract Address"
              onChange={handleChange('contractAddr')}
              placeholder="0x..."
            />
          </FormControl>
        </Grid>

        <Grid xs={12} sx={{ mt: 2 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Processing...' : '코인타입 등록'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
